import * as type from "./constants";

export const createPerformanceMetrix = (payload, onSuccess) => {
  return {
    type: type.CREATE_PERFORMANCE_MATRIX,
    payload,
    onSuccess,
  };
};
